import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconStrikethrough = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12.582 23.331c0.828 0.454 1.629 0.668 2.777 0.668 2.51 0 4.139-1.175 4.139-3.231 0-1.32-0.605-2.082-1.926-2.767h3.702c0.339 0.661 0.494 1.404 0.494 2.259 0 3.151-2.617 5.074-6.329 5.074-2.003 0-3.979-0.614-5.207-1.415l0.16-3.739h1.656l0.534 3.151zM18.123 15.333h-5.843c-1.072-0.935-1.701-2.135-1.701-3.726 0-3.071 2.59-4.94 6.009-4.94 1.789 0 3.231 0.534 4.38 1.389l-0.16 3.498h-1.629l-0.561-3.018c-0.694-0.374-1.362-0.534-2.19-0.534-2.030 0-3.605 1.042-3.605 3.018 0 1.656 1.095 2.644 3.018 3.392l1.068 0.401c0.438 0.171 0.842 0.344 1.215 0.522zM6.667 16c0-0.368 0.298-0.667 0.667-0.667h17.333c0.368 0 0.667 0.299 0.667 0.667s-0.299 0.667-0.667 0.667h-17.333c-0.368 0-0.667-0.299-0.667-0.667z"
	})
});
export { SvgIconStrikethrough as ReactComponent };
